import React, { Fragment } from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';

import { SmallHeader, SText, Spacer, Divider } from '@lafabrica/core'

const width = window.innerWidth;

const OuterWrapper = styled.div`
    width: 100%;
    border-top: 1px solid var(--light-black);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    @media only screen and (min-width: 769px) {
      flex-direction: row;
      justify-content: auto;
    }
`;

const LeftSideFooter = styled.div`
  width: -webkit-fill-available;
  text-align: center;
  justify-content: center;
  flex: 1;
  padding: 20px 40px;

  @media only screen and (min-width: 769px) {
    width: auto;
    text-align: left;
    justify-content: flex-start;
  }
`

const RightSideFooter = styled.div`
  padding: 20px 0px;
  width: -webkit-fill-available;
  justify-content: center;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;

  @media only screen and (min-width: 769px) {
    padding: 20px 40px;
    width: auto;
    justify-content: flex-end;
  }
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 10px;

  @media only screen and (min-width: 769px) {
    margin: 0 30px;
  }
`

const FooterLink = styled(SText)`
  font-weight: bold;
  cursor: pointer;
  color: var(--black);
  opacity: 0.8;
  text-decoration: none;

  &:hover {
    color: var(--accent);
  }
`

export const Footer = ({leftSide, rightSideItems=[], backgroundColor='var(--white)', outerStyle = {}}) => {

  if (width < 769){
    return (
      <OuterWrapper style={{backgroundColor: backgroundColor, ...outerStyle}}>
        <RightSideFooter>
          {rightSideItems.map(item =>
            <Column key={item.header}>
              <SmallHeader>{item.header}</SmallHeader>
              <Spacer />
              {item.items.map(k =>
                <Fragment>
                  {k.external ?
                    <FooterLink>
                      <a href={k.onClick} target="_blank" noopener noreferrer>
                        {k.name}
                      </a>
                    </FooterLink>
                    :
                    <FooterLink onClick={k.onClick}>{k.name}</FooterLink>
                  }
                  <Spacer times={0.5} />
                </Fragment>
              )}
            </Column>
          )}
        </RightSideFooter>
        <div style={{margin: 'auto'}}>
          <Spacer />
          <Divider height={0.25} width={300} color={"var(--light-black)"} solid />
          <Spacer />
        </div>
        <LeftSideFooter>
          {leftSide}
        </LeftSideFooter>
      </OuterWrapper>
    )
  }

  return (
      <OuterWrapper style={{backgroundColor: backgroundColor, ...outerStyle}}>
        <LeftSideFooter>
          {leftSide}
        </LeftSideFooter>
        <RightSideFooter>
          {rightSideItems.map(item =>
            <Column key={item.header}>
              <SmallHeader>{item.header}</SmallHeader>
              <Spacer />
              {item.items.map(k =>
                <Fragment>
                  {k.external ?
                      <FooterLink>
                        <a href={k.onClick} target="_blank" noopener noreferrer>
                          {k.name}
                          </a>
                      </FooterLink> :
                      <FooterLink onClick={k.onClick}>{k.name}</FooterLink>
                  }
                  <Spacer times={0.5} />
                </Fragment>
              )}
            </Column>
          )}
        </RightSideFooter>
      </OuterWrapper>

  );
};
